var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-table-menu"},_vm._l((_vm.showTableActions),function(item){return _c('fm-btn',{key:item.key,attrs:{"text":"","size":"small"},on:{"click":function($event){return _vm.clickFmTableMenu(item.key)}}},[_vm._v(" "+_vm._s(item.label || item.getLabel(_vm.rowData))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }